import {convertStringToCamelCase} from 'shared/web';

import i18n from '../../../i18n/i18n';

/**
 * Tries to translate a raw attribute label (e.g. from spreadsheet column) using
 * entity.overviewParameters.labels.* keys. Normalizes key to camelCase for lookup.
 * Returns the original label when no translation is found.
 */
export function translateAttributeLabel(rawLabel: string): string {
  const normalized = convertStringToCamelCase(rawLabel);
  const key = `entity.overviewParameters.labels.${normalized}`;
  return i18n.t(key, {defaultValue: rawLabel});
}
